import React from 'react';

const CaseDetail = () => {
    return (
        <div className="p-6">
            <h2 className="text-2xl font-bold">Case Details</h2>
            <p>Loading case information...</p>
        </div>
    );
};

export default CaseDetail;